import { Injectable } from '@angular/core';
import { SSMRequestModel } from '../business-entities/SSMRequest-model';
import { SSMDataService } from '../data-services/SSM-data.service';
@Injectable({
    providedIn: 'root'
})
export class SSMBusinessService {
    constructor(private service: SSMDataService) {
    }
    async ExportSSM(WoNo:string,dealerId:string,brand:string):Promise<any>{
        return this.service.ExportSSM(WoNo,dealerId,brand);
    }
    async ImportSSM(model:SSMRequestModel):Promise<any>{
        return this.service.ImportSSM(model);
    }
    async DeleteSSM(WoNo:string,dealerId):Promise<any>{
        return this.service.DeleteSSM(WoNo,dealerId);
    }
    
}